import React from "react";

import { useSelector } from "react-redux";
import WordColumn from "../WordColumn";
import "./WordColumnsContainer.css";

const WordColumnsContainer = (props) => {
  const selectedWords = useSelector(
    (state) => state.publicPuzzleSlice.puzzle?.selectedWords
  );

  const { isLive, newsieGrid, correctGuess} = props;
  return (
    <div className="word-columns-container">
      {newsieGrid?.map((wordColumn, i) => (
        <WordColumn
          isLive={isLive}
          key={i}
          columnIndex={i}
          words={wordColumn}
          selected={selectedWords && selectedWords[i]}
          correctGuess={correctGuess} 
        />
      ))}
    </div>
  );
};

export default WordColumnsContainer;
